
import { Company } from "@/models/company";
import { AuthService } from "@/services/auth-service";
import Vue from "vue";
import AppCompanyInfoNavigation from "./CompanyInfoNavigation.vue";
import AppContainerWithScrollProp from "./ContainerWithScrollProp.vue";

export default Vue.extend({
	props: {
		company: {
			type: Object as ()=>Company,
			required: true
		},
		noScroll: Boolean
	},
	computed: {
		editCompanyToolTipText():string {
			return "Switch to edit mode";
		},
	},
	methods: {
		hasPermission(permission:string):boolean{
			if (!AuthService.user) return false;
			return AuthService.user.hasPermission(permission);
		},
		editCompany() {
			let currentTab = parseInt(this.$route.query.currentTab as string || "0");
			this.$router.push( {path: `/companies/${this.company.id}/edit`, query: { currentTab: `${currentTab}`} } );
		},
	},
	components: {
		AppCompanyInfoNavigation,
		AppContainerWithScrollProp
	}
});
